import { render, staticRenderFns } from "./CadastroFluxo.vue?vue&type=template&id=47b1b6a0&scoped=true&"
import script from "./CadastroFluxo.vue?vue&type=script&lang=js&"
export * from "./CadastroFluxo.vue?vue&type=script&lang=js&"
import style0 from "./CadastroFluxo.vue?vue&type=style&index=0&id=47b1b6a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b1b6a0",
  null
  
)

export default component.exports